import axios from 'axios'
import {getAdminToken} from '../auth/_requests'

const API_URL = process.env.REACT_APP_API_URL

const adminApi = axios.create({withCredentials: true})
adminApi.interceptors.request.use((config) => {
  const token = getAdminToken()
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export function getRequestLogs(params: {
  date?: string
  days?: number
  sort?: string
  order?: string
  search?: string
  min_requests?: number
}): Promise<{data: any}> {
  return adminApi.get(`${API_URL}/admin/request-logs`, {params})
}

export function getProfileLogs(profileId: string, days?: number): Promise<{data: any}> {
  return adminApi.get(`${API_URL}/admin/request-logs/profile/${profileId}`, {params: {days}})
}
